export const backgroundImageUrls = [
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/office-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/office-space-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/lobby-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/meeting-room-1280-2.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/sky-2.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/coffee-shop-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/samos-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/cafe-1280-2.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/cafe-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/coworking-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/saxon-switzerland-539418_1280.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/porch-691330_1280.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/mountains-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/splashing-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/nature-1280-1.jpg",
    "https://r-link-dev.nyc3.digitaloceanspaces.com/background/aurora-1.jpg"
];